import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import 'flowbite/dist/flowbite.min.js';

import './assets/tokens.css';     // design system: tokens (claro/escuro)
import './assets/components.css'; // design system: classes canônicas
import './assets/main.css';       // Tailwind + globais
import { initTheme } from './composables/useTheme';
import 'flowbite';

import GAuth from "vue3-google-signin";

import router from './router';


initTheme();

const app = createApp(App);

const gAuthOptions = {
  clientId:
    "242881893652-a2arkj21m8ensfmam1hu6cgluapqjep3.apps.googleusercontent.com",
  scope: "email profile",
  prompt: "consent",
};


app.use(createPinia())
app.use(router);

app.use(GAuth, gAuthOptions);

app.mount('#app');
